// Spanish for the field area: Customer Codes, Maps, Time Off, Job Checklist.
// English text (exact) -> Spanish.
const dict = {
  /* ---------------------------------------------------- Customer Codes -- */
  "You do not have permission to delete this code.": "No tiene permiso para eliminar este código.",
  "Customer Codes": "Códigos de Clientes",
  "Add Customer Code": "Agregar Código de Cliente",
  "Edit Code": "Editar Código",
  "Code Details": "Detalles del Código",
  "Property": "Propiedad",
  "Property:": "Propiedad:",
  "Select Property": "Seleccionar Propiedad",
  "Code 1": "Código 1",
  "Code 2": "Código 2",
  "Code 3": "Código 3",
  "Code 1:": "Código 1:",
  "Code 2:": "Código 2:",
  "Code 3:": "Código 3:",
  "Location 1": "Ubicación 1",
  "Location 2": "Ubicación 2",
  "Location 3": "Ubicación 3",
  "Location 1:": "Ubicación 1:",
  "Location 2:": "Ubicación 2:",
  "Location 3:": "Ubicación 3:",
  "Search by Property": "Buscar por Propiedad",
  "Sort By": "Ordenar Por",
  "Sort by": "Ordenar por",
  "Property (A-Z)": "Propiedad (A-Z)",
  "Property (Z-A)": "Propiedad (Z-A)",
  "Actions": "Acciones",
  "Details": "Detalles",
  "Are you sure you want to delete?": "¿Seguro que quiere eliminar?",

  /* -------------------------------------------------------------- Maps -- */
  "Maps": "Mapas",
  "Please fill out the {field} field.": "Por favor llena el campo {field}.",
  "Files are still uploading. Please wait.": "Los archivos todavía se están subiendo. Por favor espera.",
  "Property Maps": "Mapas de Propiedades",
  "Property Maps List": "Lista de Mapas de Propiedades",
  "Click Here to Add Maps": "Haz Clic Aquí para Agregar Mapas",
  "Add Maps": "Agregar Mapas",
  "Map Details": "Detalles del Mapa",
  "Site Name": "Nombre del Sitio",
  "Site Name:": "Nombre del Sitio:",
  "Select Site Name": "Seleccionar Nombre del Sitio",
  "Location": "Ubicación",
  "Location:": "Ubicación:",
  "Notes:": "Notas:",
  "File Upload": "Subir Archivo",
  "Files:": "Archivos:",
  "File {n}": "Archivo {n}",
  "Image {n}": "Imagen {n}",
  "Images": "Imágenes",
  "Uploading...": "Subiendo...",
  "Uploading": "Subiendo",

  /* ---------------------------------------------------------- Time Off -- */
  "Time Off": "Tiempo Libre",
  "There was a problem submitting your request. Please try again.":
    "Hubo un problema al enviar su solicitud. Por favor intente de nuevo.",
  "Enter the time they need to leave.": "Ingresa la hora a la que necesita salir.",
  "Enter the time they will get in.": "Ingresa la hora a la que va a llegar.",
  "The end date cannot be before the start date.": "La fecha final no puede ser antes de la fecha de inicio.",
  "Someone": "Alguien",
  "{a} and {b}": "{a} y {b}",
  "{list}, and {last}": "{list} y {last}",
  "Requests for vacation, personal days, leaving early or coming in late. You will be warned before submitting if someone else has already asked for the same days.":
    "Solicitudes de vacaciones, días personales, salir temprano o llegar tarde. Se te avisará antes de enviar si alguien más ya pidió los mismos días.",
  "Request time off": "Pedir tiempo libre",
  "Name, type or reason": "Nombre, tipo o motivo",
  "All statuses": "Todos los estados",
  "Start date": "Fecha de inicio",
  "End date": "Fecha final",
  "Person": "Persona",
  "Recently submitted": "Enviadas recientemente",
  "Hide people no longer active": "Ocultar personas que ya no están activas",
  "{shown} of {total}": "{shown} de {total}",
  "Dates": "Fechas",
  "Days": "Días",
  "Type": "Tipo",
  "Submitted": "Enviada",
  "Loading requests...": "Cargando solicitudes...",
  "No time off requested yet. Use Request time off to submit the first one.":
    "Todavía no se ha pedido tiempo libre. Usa Pedir tiempo libre para enviar la primera solicitud.",
  "No requests match the current search and filters.": "Ninguna solicitud coincide con la búsqueda y los filtros.",
  "Partial": "Parcial",
  "No longer active": "Ya no está activo",
  "Request details": "Detalles de la solicitud",
  "Type:": "Tipo:",
  "Paid time type:": "Tipo de tiempo pagado:",
  "Paid time type": "Tipo de tiempo pagado",
  "Reason:": "Motivo:",
  "Reason": "Motivo",
  "Status:": "Estado:",
  "Submitted:": "Enviada:",
  "Attachment {n}": "Adjunto {n}",
  "No notes yet.": "Todavía no hay notas.",
  "Add a note to this request": "Agrega una nota a esta solicitud",
  "Attach files": "Adjuntar archivos",
  "Add note": "Agregar nota",
  "Change dates": "Cambiar fechas",
  "Pick the person the time off is for, then the days they need.":
    "Escoge la persona para quien es el tiempo libre y luego los días que necesita.",
  "Select a person": "Selecciona una persona",
  "What do they need?": "¿Qué necesita?",
  "Full day(s) off": "Día(s) completo(s) libre(s)",
  "Leave early": "Salir temprano",
  "Come in late": "Llegar tarde",
  "Leaving at": "Sale a las",
  "Getting in at": "Llega a las",
  "Select a type": "Selecciona un tipo",
  "Vacation": "Vacaciones",
  "Personal": "Personal",
  "Sick": "Enfermedad",
  "Unpaid": "Sin pago",
  "Submitting...": "Enviando...",
  "Submit request": "Enviar solicitud",
  "Moving these days runs the same overlap check as a new request.":
    "Al mover estos días se revisa si chocan con otras solicitudes, igual que una solicitud nueva.",
  "Save dates": "Guardar fechas",
  "Someone else already asked for these days": "Alguien más ya pidió estos días",
  "Requests that stack up on the same days are more likely to be turned down. If the plans are flexible, different dates have a much better chance of approval.":
    "Las solicitudes que caen en los mismos días tienen más probabilidad de ser rechazadas. Si sus planes son flexibles, otras fechas tienen mucha mejor oportunidad de ser aprobadas.",
  "{people} has time off requested that overlaps this one.": "{people} tiene tiempo libre pedido que coincide con esta solicitud.",
  "{people} have time off requested that overlaps this one.": "{people} tienen tiempo libre pedido que coincide con esta solicitud.",
  "Overlapping requests": "Solicitudes que coinciden",
  "Unknown user": "Usuario desconocido",
  "Shares {n} day:": "Comparte {n} día:",
  "Shares {n} days:": "Comparte {n} días:",
  "You can still go ahead if these are the days you need. This is a heads-up, not a block.":
    "Todavía puede continuar si estos son los días que necesita. Esto es solo un aviso, no un bloqueo.",
  "Pick different dates": "Escoger otras fechas",
  "Working...": "Procesando...",
  "Submit anyway": "Enviar de todos modos",
  "Save anyway": "Guardar de todos modos",
  // describeEntry() phrases (shared util, translated for display)
  "Time off": "Tiempo libre",
  "Leaving early": "Sale temprano",
  "Coming in late": "Llega tarde",
  "Left early": "Salió temprano",
  "Came in late": "Llegó tarde",
  "Called out": "Avisó que no viene",
  "No call / no show": "No avisó / no se presentó",
  "Leaving early at {time}": "Sale temprano a las {time}",
  "Coming in late at {time}": "Llega tarde a las {time}",
  "Left early at {time}": "Salió temprano a las {time}",
  "Came in late at {time}": "Llegó tarde a las {time}",

  /* ----------------------------------------------------- Job Checklist -- */
  "Checklist": "Lista de Verificación",
  "Job Checklist": "Lista de Verificación del Trabajo",
  "Job Checklist / Punch List": "Lista de Verificación / Lista de Pendientes",
  "Job Checklist / Punch List Report": "Reporte de Lista de Verificación / Lista de Pendientes",
  "Checklist Report - WO {wo}": "Reporte de Lista de Verificación - WO {wo}",
  "Remove this checklist / punch-list item?": "¿Quitar este punto de la lista de verificación / pendientes?",
  "Open": "Pendiente",
  "by {name}": "por {name}",
  "on {date}": "el {date}",
  "Checklist image": "Imagen de la lista",
  "WO:": "WO:",
  "Site:": "Sitio:",
  "Scope:": "Alcance:",
  "Total: {n}": "Total: {n}",
  "Completed: {n}": "Completados: {n}",
  "Open: {n}": "Pendientes: {n}",
  "Progress: {n}%": "Avance: {n}%",
  "No checklist items.": "No hay puntos en la lista.",
  "Loading job data...": "Cargando datos del trabajo...",
  "No site name": "Sin nombre de sitio",
  "← Back to Job Details": "← Volver a los Detalles del Trabajo",
  "Hide Completed": "Ocultar Completados",
  "Show Completed": "Mostrar Completados",
  "Download Report": "Descargar Reporte",
  "{n}% complete": "{n}% completado",
  "{n} total": "{n} en total",
  "{n} completed": "{n} completados",
  "{n} open": "{n} pendientes",
  "Add Punch-List Item": "Agregar Punto Pendiente",
  "Example: Touch up paint at living room window": "Ejemplo: Retocar la pintura en la ventana de la sala",
  "+ Add Item": "+ Agregar Punto",
  "Mark item open": "Marcar punto como pendiente",
  "Mark item completed": "Marcar punto como completado",
  "Mark open": "Marcar pendiente",
  "Mark completed": "Marcar completado",
  "Item {n}": "Punto {n}",
  "Punch-list notes / what needs to be done": "Notas / lo que hay que hacer",
  "Add details, correction needed, location, materials, follow-up instructions, etc.":
    "Agrega detalles, corrección necesaria, ubicación, materiales, instrucciones a seguir, etc.",
  "+ Add Images": "+ Agregar Imágenes",
  "Remove image from checklist": "Quitar imagen de la lista",
  "All completed items are hidden.": "Todos los puntos completados están ocultos.",
  "No checklist items yet. Add your first punch-list item above.":
    "Todavía no hay puntos en la lista. Agregue su primer punto pendiente arriba.",
  "Saving": "Guardando",
  "Save Checklist": "Guardar Lista",
  "Checklist preview": "Vista previa de la lista",
  // Status messages (stored in English, shown through t())
  "Job not found.": "No se encontró el trabajo.",
  "There was a problem loading this checklist.": "Hubo un problema al cargar esta lista.",
  "Image upload failed. Please try again.": "No se pudo subir la imagen. Por favor intente de nuevo.",
  "There was an error saving the checklist.": "Hubo un error al guardar la lista.",
  "Checklist saved.": "Lista guardada.",
  "Checklist saved. {n} completed item was added to the job notes.":
    "Lista guardada. Se agregó {n} punto completado a las notas del trabajo.",
  "Checklist saved. {n} completed items were added to the job notes.":
    "Lista guardada. Se agregaron {n} puntos completados a las notas del trabajo.",
};

export default dict;
